// extracted by mini-css-extract-plugin
export default {"header-container":"header_header-container__TY9ha","logo":"header_logo__wLirW","auth-buttons":"header_auth-buttons__X7RM1"};